import o from"./browser/index.js";import*as r from"./common/utils.js";var m={...r,...o};export{m as default};
//# sourceMappingURL=index.js.map
